import { useQuery } from "@tanstack/react-query";
import { useCurrentStateAndParams } from "@uirouter/react";

import Sentry from "@similarweb/sentry-logger";

import DurationService from "app/services/DurationService";
import { DefaultFetchService } from "app/services/fetchService";

import { END_POINT_PATH_MMX_BETA_PIE_CHART } from "../../../../components/common/consts";
import type { IBetaTrafficSources, IChannelsBetaData } from "../../../types/types";
import { transformMmxBetaData } from "../utils";

interface ApiResponse {
    Data: { Total: Record<string, IBetaTrafficSources> };
}

const fetchService = DefaultFetchService.getInstance();

const fetchBetaChannelsOverviewData = async (params: Record<string, any>): Promise<IChannelsBetaData> => {
    try {
        const res: ApiResponse = await fetchService.get(END_POINT_PATH_MMX_BETA_PIE_CHART, params);
        return transformMmxBetaData(res.Data);
    } catch (err) {
        Sentry.error(`Beta data for mmx fetch failed for ${END_POINT_PATH_MMX_BETA_PIE_CHART}`, err);
        return null;
    }
};
export const useBetaChannelsOverviewData = () => {
    const { params } = useCurrentStateAndParams();
    const { webSource, isWWW, duration, comparedDuration, key, country } = params;
    const { from, to, isWindow } = DurationService.getDurationData(duration, comparedDuration).forAPI;

    const apiParams = {
        country,
        from,
        includeSubDomains: isWWW === "*",
        isWindow,
        keys: key,
        timeGranularity: duration === "28d" ? "Daily" : "Monthly",
        to,
        webSource,
        MMXBeta: true,
    };

    const { data, isLoading, isError } = useQuery<IChannelsBetaData>({
        queryKey: ["betaChannelsOverview", apiParams],
        queryFn: () => fetchBetaChannelsOverviewData(apiParams),
        staleTime: 5 * 60 * 1000,
    });

    return { data, isLoading, isError };
};
